import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonIcon,
  IonItem,
  IonText,
} from "@ionic/react";
import { alertCircle } from "ionicons/icons";
import { useEffect, useState } from "react";
import { v4 } from "uuid";
import { makeDELETERequest, makeGETRequest } from "../../request/rawRequest";

interface Notification {
  _id: string;
  title: string;
  message: string;
  viewed: boolean;
  email: string;
  url: string;
}

const Notifications: React.FC = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  useEffect(() => {
    makeGETRequest("/notifications").then((res: any[]) =>
      setNotifications((old) =>
        res
          .filter((notif) => notif.viewed === false)
          .reverse()
          .map((notif: any) => {
            const { _id, title, message, viewed, email, url } = notif;
            return {
              _id,
              title,
              message,
              viewed,
              email,
              url,
            };
          })
      )
    );
  }, []);

  return (
    <IonCard className="border-primary-contrast border-radius">
      <IonCardHeader>
        <h5
          style={{
            color: "black",
          }}
        >
          Mes notifications
        </h5>
      </IonCardHeader>
      <IonCardContent>
        {notifications.map((notification) => (
          <IonItem
            key={v4()}
            color={notification.viewed ? "" : "primary"}
            onClick={() => {
              makeDELETERequest("/notifications", {
                _id: notification._id,
              }).then((res) => {
                window.location.href = notification.url;
              });
            }}
          >
            <IonIcon icon={alertCircle} />

            <IonText>
              <p className="bold">{notification.title}</p>
              <p>{notification.message}</p>
            </IonText>
          </IonItem>
        ))}
      </IonCardContent>
    </IonCard>
  );
};

export default Notifications;
